module.exports = __webpack_public_path__ + "img/6-en.32db6b93.png";